import { useTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  Col,
  Form,
  InputNumber,
  message,
  Modal,
  Radio,
  Row,
  Space,
  Switch,
  Table,
  TableProps,
  Tabs,
  TabsProps,
  Typography
} from "antd";
import { useWatch } from "antd/es/form/Form";
import { FormInstance } from "antd/lib";
import { useEffect, useState } from "react";
import {
  getEnterpriseByCourseId,
  getMoocScoringRules,
  postConfigBlockQuizAction,
  postConfigBlockQuizEvaluate,
  postConfigBlockQuizGeneral
} from "../../../../service/course-construct/settingLessonCourse";
import { useAddLesson } from "../../../../stores/stores";
import FormItemDropdown from "../../../form-dropdown/FormItemDropdown";
import "./index.scss";
import useKeyword from "../../../../hooks/useKeyword";

var indexDB = require("idbcache").default;

interface DataType {
  key: string;
  numberPoint: string;
  letterPoint: string;
  classification: string;
}

interface SettingLessonCourseProps {
  form: FormInstance;
  setSettingLessonModal: (value: boolean) => void;
  generalSettingValue?: any
  actionSettingValue?: any
  evaluateSettingValue?: any
  settingLessonModal?: boolean
}

export default function SettingLessonCourse({ generalSettingValue, actionSettingValue, evaluateSettingValue, form, settingLessonModal, setSettingLessonModal }: SettingLessonCourseProps) {
  const { t } = useTranslation();
  const [keyActive, setKeyActive] = useState<string>("1");
  const [resetModal, setResetModal] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rules, setRules] = useState<any>([]);
  const { settingPopupQuestion, setSettingPopupQuestion, updateTimeToPlayFromOutside, setDefaultTimeToPlay } = useAddLesson(state => ({
    settingPopupQuestion: state.settingPopupQuestion,
    setSettingPopupQuestion: state.setSettingPopupQuestion,
    updateTimeToPlayFromOutside: state.updateTimeToPlayFromOutside,
    setDefaultTimeToPlay: state.setDefaultTimeToPlay,
  }));
  const blockId = useKeyword("blockId")
  const courseId = useKeyword("courseId")

  // Display checkbox general setting
  const checkDefaultQuestion = useWatch("defaultQuestion", form);
  const checkShowFeedback = useWatch("showFeedback", form);
  const checkFormatQuiz = useWatch("formatQuiz", form);
  const checkResultOfEvaluationCheckbox = useWatch("showResultOfEvaluation", form);
  const checkFeedbackContentCheckbox = useWatch("showFeedbackContent", form);
  const checkCorrectAnswerCheckbox = useWatch("showCorrectAnswer", form);

  // Display checkbox action setting
  const checkNumberActionEvaluateCheckbox = useWatch("numberActionEvaluateCheckbox", form);
  const checkTimeBetweenExecutionsCheckbox = useWatch("timeBetweenExecutionsCheckbox", form);
  const checkCompletionTimeCheckbox = useWatch("completionTimeCheckbox", form);
  const checkExecutionTimeExpiredCheckbox = useWatch("executionTimeExpired", form);
  const checkExecutionTimeExpiredOptionCheckbox = useWatch("executionTimeExpiredOption", form) === "1";
  const checkTimeForQuizCheckbox = useWatch("timeForQuizCheckbox", form);

  // Display switch evaluate setting
  const checkAutomaticScoringSwitch = useWatch("automaticScoring", form);
  const checkResultsCompletionSwitch = useWatch("showResultsCompletion", form);
  const checkrecordResultsSwitch = useWatch("recordResultsSwitch", form);

  useEffect(() => {
    form.setFieldsValue({
      formatQuiz: checkDefaultQuestion ? 2 : (checkFormatQuiz ? checkFormatQuiz : 0),
    });
  }, [checkDefaultQuestion, settingLessonModal])

  const columns: TableProps<DataType>["columns"] = [
    {
      title: t("Thang điểm số", "Thang điểm số"),
      dataIndex: "numberPoint",
      key: "numberPoint",
    },
    {
      title: t("Thang điểm chữ", "Thang điểm chữ"),
      dataIndex: "letterPoint",
      key: "letterPoint",
    },

    {
      title: t("Xếp loại", "Xếp loại"),
      dataIndex: "classification",
      key: "classification",
    },
  ];


  const resultCheckboxOptions = [
    { id: "0", name: t("Tất cả câu hỏi", "Tất cả câu hỏi") },
    { id: "1", name: t("Chỉ câu hỏi đã trả lời", "Chỉ câu hỏi đã trả lời") },
    { id: "2", name: t("Chỉ câu hỏi trả lời đúng", "Chỉ câu hỏi trả lời đúng") },
    { id: "3", name: t("Chỉ câu hỏi trả lời sai", "Chỉ câu hỏi trả lời sai") },
  ];

  const data: DataType[] = rules.map((item: any) => (
    {
      key: item.id.toString(),
      numberPoint: `${item.scoreNumberMin} - ${item.scoreNumberMax}`,
      letterPoint: item.scoreText,
      classification: item.classify
    }));

  // Get rules by enterprise
  const getEnterprise = async (courseId: string) => {
    try {
      const { data } = await getEnterpriseByCourseId(courseId);
      if (data) {
        getScoringRule(data.data);
      }
    } catch (err) { }
  }

  const getScoringRule = async (enterpriseUuid: string) => {
    try {
      const { data } = await getMoocScoringRules(enterpriseUuid);
      if (data) {
        setRules(data.data)
      }
    } catch (err) { }
  }

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  // Setting Modal
  const handleCancelSetting = () => {
    setSettingLessonModal(false);
    setResetModal(!resetModal);
  }

  // Tabs
  const onTabClick = (key: string) => {
    setKeyActive(key);
  }

  // Call api setting
  const postGeneralSetting = async (values: any) => {
    try {
      await postConfigBlockQuizGeneral(values).then((res) => {
        if (res.status === 200) {
          message.success(t("Lưu cài đặt thành công!", "Lưu cài đặt thành công!"));
          setSettingLessonModal(false);
          setResetModal(!resetModal);
        }
      })
    } catch (err) { }
  }

  const postBlockQuizAction = async (values: any) => {
    try {
      await postConfigBlockQuizAction(values).then((res) => {
        if (res.status === 200) {
          message.success(t("Lưu cài đặt thành công!", "Lưu cài đặt thành công!"));
          setSettingLessonModal(false);
        }
        setResetModal(!resetModal);

        // Cập nhật timeToPlay và defaultTimeToPlay trong store
        if (values.timeForQuiz && checkTimeForQuizCheckbox) {
          updateTimeToPlayFromOutside(values.timeForQuiz);
          setDefaultTimeToPlay(values.timeForQuiz);
        }
      })
    } catch (err) { }
  }

  const postBlockQuizEvaluate = async (values: any) => {
    try {
      await postConfigBlockQuizEvaluate(values).then((res) => {
        if (res.status === 200) {
          message.success(t("Lưu cài đặt thành công!", "Lưu cài đặt thành công!"));
          setSettingLessonModal(false);
        }
        setResetModal(!resetModal);
      })
    } catch (err) { }
  }

  // onFinish setting
  const onFinishSetting = (values: any) => {
    if (keyActive) {
      if (keyActive === "1") {
        const dataSetting = {
          courseBlockId: blockId,
          randomQuiz: values.randomQuestion,
          sequentiallyQuiz: values.defaultQuestion,
          showQuizScore: values.showMaxPoint,
          showHintQuiz: values.showHintQuiz,
          showFeedback: values.showFeedback,
          showResultOfEvaluation: values.showFeedback ? values.showResultOfEvaluation : false,
          resultOfEvaluationOption: (values.showFeedback && values.showResultOfEvaluation) ? values.resultOfEvaluationOption : null,
          showFeedbackContent: values.showFeedback ? values.showFeedbackContent : false,
          feedbackContentOption: (values.showFeedback && values.showFeedbackContent) ? values.feedbackContentOption : null,
          showCorrectAnswer: values.showFeedback ? values.showCorrectAnswer : false,
          correctAnswerOption: (values.showFeedback && values.showCorrectAnswer) ? values.correctAnswerOption : null,
          formatQuiz: values.formatQuiz,
        }
        postGeneralSetting(dataSetting);
      } else if (keyActive === "2") {
        const dataSetting = {
          courseBlockId: blockId,
          numberActionEvaluate: (values.numberActionEvaluate && checkNumberActionEvaluateCheckbox) ? values.numberActionEvaluate : null,
          timeBetweenExecutions: (values.timeBetweenExecutions && checkTimeBetweenExecutionsCheckbox) ? values.timeBetweenExecutions : null,
          completionTime: (values.completionTime && checkCompletionTimeCheckbox) ? values.completionTime : null,
          executionTimeExpired: (checkCompletionTimeCheckbox) ? values.executionTimeExpired : null,
          executionTimeExpiredOption: (checkCompletionTimeCheckbox && checkExecutionTimeExpiredCheckbox) ? values.executionTimeExpiredOption : null,
          executionTimeExpiredValue: (values.executionTimeExpiredValue && checkCompletionTimeCheckbox && checkExecutionTimeExpiredCheckbox && checkExecutionTimeExpiredOptionCheckbox) ? values.executionTimeExpiredValue : null,
          timeForQuiz: (values.timeForQuiz && checkTimeForQuizCheckbox && values.defaultQuestion) ? values.timeForQuiz : null,
        }
        postBlockQuizAction(dataSetting);
      } else {
        const dataSetting = {
          courseBlockId: blockId,
          automaticScoring: values.automaticScoring,
          typeScore: Number(values.typeScore),
          minimumScore: Number(values.minimumScore),
          scoreFactor: values.scoreFactor ? values.scoreFactor : null,
          recordResults: checkrecordResultsSwitch ? Number(values.recordResults) : null,
          showResultsCompletion: values.automaticScoring ? values.showResultsCompletion : false,
          showResultsCompletionOption: (values.showResultsCompletionOption && checkAutomaticScoringSwitch && checkResultsCompletionSwitch) ? values.showResultsCompletionOption : null,
        }
        postBlockQuizEvaluate(dataSetting);
      }
    }
  }


  // items tab
  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: t("Cài đặt chung", "Cài đặt chung"),
      children: (
        <Form layout="horizontal" className="form-general-setting" form={form} onFinish={onFinishSetting}>
          <Typography.Title level={5} className="title-label">
            {t("Thiết lập hiển thị", "Thiết lập hiển thị")}
          </Typography.Title>

          <Row gutter={[4, 4]} className="row-form-setting">
            <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Ngẫu nhiên hóa thứ tự câu hỏi", "Ngẫu nhiên hóa thứ tự câu hỏi")}
              </Typography.Text>
              <Form.Item name="randomQuestion" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Trả lời tuần tự câu hỏi", "Trả lời tuần tự câu hỏi")}
              </Typography.Text>
              <Form.Item name="defaultQuestion" valuePropName="checked">
                <Switch defaultChecked onChange={(value) => {
                  setSettingPopupQuestion({
                    defaultQuestion: value,
                  })
                }} />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Hiển thị điểm tối đa mỗi câu hỏi", "Hiển thị điểm tối đa mỗi câu hỏi")}
              </Typography.Text>
              <Form.Item name="showMaxPoint" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Hiển thị hướng dẫn trả lời câu hỏi", "Hiển thị hướng dẫn trả lời câu hỏi")}
              </Typography.Text>
              <Form.Item name="showHintQuiz" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Hiển thị phản hồi", "Hiển thị phản hồi")}
              </Typography.Text>
              <Form.Item name="showFeedback" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-setting">
              <Form.Item name="showResultOfEvaluation" valuePropName="checked">
                <Checkbox disabled={!checkShowFeedback}>
                  <Typography.Text className="text-label">
                    {t("Hiển thị kết quả đánh giá", "Hiển thị kết quả đánh giá")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>

              <Space className="display-dropdown">
                <Form.Item name="resultOfEvaluationOption">
                  <FormItemDropdown disabled={!checkShowFeedback || !checkResultOfEvaluationCheckbox}
                    options={resultCheckboxOptions} />
                </Form.Item>
              </Space>
            </Col>

            <Col span={24} className="col-form-setting">
              <Form.Item name="showFeedbackContent" valuePropName="checked">
                <Checkbox disabled={!checkShowFeedback}>
                  <Typography.Text className="text-label">
                    {t("Hiển thị phản hồi", "Hiển thị phản hồi")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>
              <Space className="display-dropdown">
                <Form.Item name="feedbackContentOption">
                  <FormItemDropdown disabled={!checkShowFeedback || !checkFeedbackContentCheckbox}
                    options={resultCheckboxOptions} />
                </Form.Item>
              </Space>
            </Col>

            <Col span={24} className="col-form-setting">
              <Form.Item name="showCorrectAnswer" valuePropName="checked">
                <Checkbox disabled={!checkShowFeedback}>
                  <Typography.Text className="text-label">
                    {t("Hiển thị đáp án đúng", "Hiển thị đáp án đúng")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>
              <Space className="display-dropdown">
                <Form.Item name="correctAnswerOption">
                  <FormItemDropdown disabled={!checkShowFeedback || !checkCorrectAnswerCheckbox}
                    options={resultCheckboxOptions} />
                </Form.Item>
              </Space>
            </Col>


            <Col span={24} className="col-form-checkbox">
              <Typography.Title level={5} className="title-label">
                {t("Thiết lập bố cục", "Thiết lập bố cục")}
              </Typography.Title>
              <Form.Item name="formatQuiz">
                <Radio.Group className="wrapper-radio">
                  <Space direction="vertical">
                    <Radio value={0} disabled={checkDefaultQuestion}>{t("Cơ bản", "Cơ bản")}</Radio>
                    <Typography.Text className="des-label">
                      {t("Hiển thị tất cả câu hỏi trên một trang", "Hiển thị tất cả câu hỏi trên một trang")}
                    </Typography.Text>
                    <Radio value={1} disabled={checkDefaultQuestion}>{t("Theo từng phần", "Theo từng phần")}</Radio>
                    <Typography.Text className="des-label">
                      {t("Hiển thị mỗi trang một phần", "Hiển thị mỗi trang một phần")}
                    </Typography.Text>
                    <Radio value={2}>{t("Theo từng câu hỏi", "Theo từng câu hỏi")}</Radio>
                    <Typography.Text className="des-label">
                      {t("Hiển thị mỗi trang một câu hỏi", "Hiển thị mỗi trang một câu hỏi")}
                    </Typography.Text>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col span={24} className="btn-submit-form">
              <Button className="btn btn-default" onClick={handleCancelSetting}>
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary" onClick={() => form.submit()}>
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      key: "2",
      label: t("Cài đặt thực hiện", "Cài đặt thực hiện"),
      children: (
        <Form layout="horizontal" className="form-action-setting" form={form} onFinish={onFinishSetting}>
          <Typography.Title level={5} className="title-label">
            {t("Giới hạn thực hiện đánh giá", "Giới hạn thực hiện đánh giá")}
          </Typography.Title>

          <Row gutter={[4, 4]} className="row-form-setting">
            <Col span={24} className="col-form-setting">
              <Form.Item name="numberActionEvaluateCheckbox" valuePropName="checked">
                <Checkbox>
                  <Typography.Text className="text-label">
                    {t("Giới hạn lượt thực hiện đánh giá", "Giới hạn lượt thực hiện đánh giá")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>
              <Form.Item name="numberActionEvaluate">
                <InputNumber
                  disabled={!checkNumberActionEvaluateCheckbox}
                  min={1} max={500} addonAfter={t("lần", "lần")}
                  formatter={value => `${value}`.replace('.', '')}
                />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-setting">
              <Form.Item name="timeBetweenExecutionsCheckbox" valuePropName="checked">
                <Checkbox>
                  <Typography.Text className="text-label">
                    {t("Thời gian chờ thực hiện giữa các lượt thực hiện", "Thời gian chờ thực hiện giữa các lượt thực hiện")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>
              <Form.Item name="timeBetweenExecutions">
                <InputNumber
                  disabled={!checkTimeBetweenExecutionsCheckbox}
                  min={1} max={500} addonAfter={t("phút", "phút")}
                  formatter={value => `${value}`.replace('.', '')}
                />
              </Form.Item>
            </Col>
            <Col span={24} className="col-form-setting">
              <Form.Item name="completionTimeCheckbox" valuePropName="checked">
                <Checkbox>
                  <Typography.Text className="text-label">
                    {t("Giới hạn thời gian hoàn thành đánh giá", "Giới hạn thời gian hoàn thành đánh giá")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>
              <Form.Item name="completionTime">
                <InputNumber
                  disabled={!checkCompletionTimeCheckbox}
                  min={1} max={500} addonAfter={t("phút", "phút")}
                  formatter={value => `${value}`.replace('.', '')}
                />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-radio">
              <Form.Item name="executionTimeExpired" valuePropName="checked">
                <Checkbox disabled={!checkCompletionTimeCheckbox}>
                  <Typography.Text className="text-label">
                    {t("Cài đặt hết thời gian thực hiện", "Cài đặt hết thời gian thực hiện")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>
              <Form.Item className="group-radio" name="executionTimeExpiredOption">
                <Radio.Group disabled={!checkExecutionTimeExpiredCheckbox || !checkCompletionTimeCheckbox}>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <Radio className="wrapper-radio" value={"0"}>{t("Tự động gửi đánh giá", "Tự động gửi đánh giá")}</Radio>
                    </Col>
                    <Col span={24} className="time-extension">
                      <Radio className="wrapper-radio" value={"1"}>{t("Gia hạn thời gian", "Gia hạn thời gian")}</Radio>
                      <Form.Item name="executionTimeExpiredValue">
                        <InputNumber
                          disabled={!(checkExecutionTimeExpiredCheckbox && checkExecutionTimeExpiredOptionCheckbox) || !checkCompletionTimeCheckbox}
                          min={1} max={500} addonAfter={t("phút", "phút")} formatter={value => `${value}`.replace('.', '')}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Radio className="wrapper-radio" value={"2"}>{t("Hủy bài đánh giá", "Hủy bài đánh giá")}</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Typography.Title level={5} className="title-label">
              {t("Giới hạn trả lời câu hỏi", "Giới hạn trả lời câu hỏi")}{" "}
            </Typography.Title>

            <Col span={24} className="col-form-setting">
              <Form.Item name="timeForQuizCheckbox" valuePropName="checked">
                <Checkbox disabled={!checkDefaultQuestion}>
                  <Typography.Text className="text-label">
                    {t("Thiết lập thời gian thực hiện mặc định", "Thiết lập thời gian thực hiện mặc định")}
                  </Typography.Text>
                </Checkbox>
              </Form.Item>
              <Form.Item name="timeForQuiz">
                <InputNumber
                  disabled={!checkTimeForQuizCheckbox || !checkDefaultQuestion}
                  min={1} max={500} addonAfter={t("giây", "giây")}
                  formatter={value => `${value}`.replace('.', '')}
                />
              </Form.Item>
            </Col>

            <Col className="btn-submit-form">
              <Button
                onClick={handleCancelSetting}
                className="btn btn-default"
              >
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-primary"
                onClick={() => form.submit()}
              >
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      key: "3",
      label: t("Cài đặt đánh giá", "Cài đặt đánh giá"),
      children: (
        <Form layout="horizontal"
          className="form-evaluate-setting"
          form={form}
          onFinish={onFinishSetting}>
          <Typography.Title level={5} className="title-label">
            {t("Cài đặt chấm điểm", "Cài đặt chấm điểm")}
          </Typography.Title>

          <Row gutter={[4, 4]} className="row-form-setting">
            <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Bật chế độ chấm điểm tự động", "Bật chế độ chấm điểm tự động")}
              </Typography.Text>
              <Form.Item name="automaticScoring" hasFeedback>
                <Switch defaultChecked />
              </Form.Item>
            </Col>

            {/* <Col span={24} className="col-form-setting">
              <Space>
                <Typography.Text className="text-label">
                  {t("Thang điểm", "Thang điểm")}
                </Typography.Text>
                <QuestionCircleOutlined style={{ color: "#1677FF" }} />
                <Typography.Text className="text-label" style={{ color: "#1677FF", cursor: "pointer" }}
                  onClick={showModal}>
                  {t("Quy tắc", "Quy tắc")}
                </Typography.Text>
              </Space>
              <Space className="display-dropdown">
                <Form.Item name="typeScore">
                  <FormItemDropdown options={pointScaleOptions} />
                </Form.Item>
              </Space>
            </Col> */}

            {/* <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Kết quả đạt tối thiểu", "Kết quả đạt tối thiểu")}
              </Typography.Text>
              <Space className="display-dropdown">
                <Form.Item name="minimumScore">
                  <FormItemDropdown
                    options={(checkTypeScore && checkTypeScore === "0" ? minNumberPoint : (checkTypeScore && checkTypeScore === 1 ? minTextPoint : minClassify))}
                  />
                </Form.Item>
              </Space>
            </Col> */}

            {/* <Col span={24} className="col-form-setting">
              <Typography.Text className="text-label">
                {t("Hệ số điểm", "Hệ số điểm")}
              </Typography.Text>
              <Space className="display-dropdown">
                <Form.Item name="scoreFactor">
                  <InputNumber min={1} max={500} formatter={value => `${value}`.replace('.', '')} />
                </Form.Item>
              </Space>
            </Col> */}

            <Col span={24} className="col-form-setting col-radio">
              <Typography.Text className="text-label">
                {t("Bật ghi nhận kết quả vào thành tích", "Bật ghi nhận kết quả vào thành tích")}
              </Typography.Text>
              <Form.Item name="recordResultsSwitch" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>

            <Col span={24} className="col-form-setting">
              <Form.Item name="recordResults" className="ml-6">
                <Radio.Group className="wrapper-radio" disabled={!checkrecordResultsSwitch}>
                  <Space direction="vertical">
                    <Radio value={"0"}>{t("Ghi nhận kết quả đầu tiên", "Ghi nhận kết quả đầu tiên")}</Radio>
                    <Radio value={"1"}>{t("Ghi nhận kết quả cuối cùng", "Ghi nhận kết quả cuối cùng")}</Radio>
                    <Radio value={"2"}>{t("Ghi nhận kết quả cao nhất", "Ghi nhận kết quả cao nhất")}</Radio>
                    <Radio value={"3"}>{t("Ghi nhận kết quả trung bình", "Ghi nhận kết quả trung bình")}</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col span={24}
              className={`col-form-setting col-checkbox ${!checkAutomaticScoringSwitch ? "col-hidden" : ""}`}>
              <Typography.Text className="text-label">
                {t("Bật hiển thị kết quả chấm điểm tự động sau khi hoàn thành", "Bật hiển thị kết quả chấm điểm tự động sau khi hoàn thành")}
              </Typography.Text>
              <Form.Item name="showResultsCompletion" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>

            <Col span={24} className={`col-form-setting ${!checkAutomaticScoringSwitch ? "col-hidden" : ""}`}>
              <Form.Item className="ml-6" name="showResultsCompletionOption">
                <Checkbox.Group style={{ width: "100%" }} disabled={!checkResultsCompletionSwitch}>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <Checkbox value="0">
                        {t("Hiển thị tổng số câu trả lời đúng", "Hiển thị tổng số câu trả lời đúng")}
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="1">{t("Hiển thị điểm tổng kết", "Hiển thị điểm tổng kết")}</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="2">
                        {t("Hiển thị số câu trả lời đúng theo từng phần", "Hiển thị số câu trả lời đúng theo từng phần")}
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="3">
                        {t("Hiển thị điểm theo từng phần", "Hiển thị điểm theo từng phần")}
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="4">
                        {t("Hiển thị thời gian thực hiện", "Hiển thị thời gian thực hiện")}
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="5">{t("Hiển thị thời gian hoàn tất", "Hiển thị thời gian hoàn tất")}</Checkbox>
                    </Col>
                    {/* <Col span={24}>
                      <Checkbox value="6">
                        {t("Hiển thị nút Xem chi tiết đáp án", "Hiển thị nút Xem chi tiết đáp án")}
                      </Checkbox>
                    </Col> */}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </Col>

            <Col span={24} className="btn-submit-form">
              <Button
                onClick={handleCancelSetting}
                className="btn btn-default"
              >
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-primary"
                onClick={() => form.submit()}
              >
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Col>
          </Row>
        </Form>
      ),
    },
  ];

  useEffect(() => {
    if (courseId) {
      getEnterprise(courseId);
    }
  }, [courseId])

  useEffect(() => {
    if (!settingLessonModal || !generalSettingValue) return;

    form.setFieldsValue({
      randomQuestion: !!generalSettingValue.randomQuiz,
      defaultQuestion: !!generalSettingValue.sequentiallyQuiz,
      showMaxPoint: !!generalSettingValue.showQuizScore,
      showHintQuiz: !!generalSettingValue.showHintQuiz,
      showFeedback: !!generalSettingValue.showFeedback,
      showResultOfEvaluation: !!generalSettingValue.showResultOfEvaluation,
      resultOfEvaluationOption: generalSettingValue.resultOfEvaluationOption ?? "0",
      showFeedbackContent: !!generalSettingValue.showFeedbackContent,
      feedbackContentOption: generalSettingValue.feedbackContentOption ?? "0",
      showCorrectAnswer: !!generalSettingValue.showCorrectAnswer,
      correctAnswerOption: generalSettingValue.correctAnswerOption ?? "0",
      formatQuiz: generalSettingValue.formatQuiz !== undefined ? Number(generalSettingValue.formatQuiz) : 1,
    });
  }, [generalSettingValue, settingLessonModal]);

  useEffect(() => {
    if (!settingLessonModal || !actionSettingValue) return;

    form.setFieldsValue({
      numberActionEvaluateCheckbox: !!actionSettingValue.numberActionEvaluate,
      numberActionEvaluate: actionSettingValue.numberActionEvaluate ?? null,
      timeBetweenExecutionsCheckbox: !!actionSettingValue.timeBetweenExecutions,
      timeBetweenExecutions: actionSettingValue.timeBetweenExecutions ?? null,
      completionTimeCheckbox: !!actionSettingValue.completionTime,
      completionTime: actionSettingValue.completionTime ?? null,
      executionTimeExpired: !!actionSettingValue.executionTimeExpired,
      executionTimeExpiredOption: actionSettingValue.executionTimeExpiredOption ?? "0",
      executionTimeExpiredValue: actionSettingValue.executionTimeExpiredValue ?? null,
      timeForQuizCheckbox: !!actionSettingValue.timeForQuiz,
      timeForQuiz: actionSettingValue.timeForQuiz ?? null,
    });
  }, [actionSettingValue, settingLessonModal]);

  useEffect(() => {
    if (!settingLessonModal || !evaluateSettingValue) return;

    form.setFieldsValue({
      automaticScoring: !!evaluateSettingValue.automaticScoring,
      typeScore: evaluateSettingValue.typeScore ?? "0",
      minimumScore: evaluateSettingValue.minimumScore ?? "0",
      scoreFactor: evaluateSettingValue.scoreFactor ?? null,
      recordResultsSwitch: !!evaluateSettingValue.recordResults,
      recordResults: evaluateSettingValue.recordResults !== undefined ? String(evaluateSettingValue.recordResults) : "0",
      showResultsCompletion: !!evaluateSettingValue.showResultsCompletion,
      showResultsCompletionOption: evaluateSettingValue.showResultsCompletionOptions ?? null,
    });
  }, [evaluateSettingValue, settingLessonModal]);

  useEffect(() => {
    if (!settingLessonModal) return;
    if (generalSettingValue || actionSettingValue || evaluateSettingValue) return;

    form.setFieldsValue({
      randomQuestion: false,
      defaultQuestion: false,
      showMaxPoint: false,
      showHintQuiz: false,
      showFeedback: false,
      showResultOfEvaluation: false,
      resultOfEvaluationOption: "0",
      showFeedbackContent: false,
      feedbackContentOption: "0",
      showCorrectAnswer: false,
      correctAnswerOption: "0",
      formatQuiz: 1,
      numberActionEvaluateCheckbox: false,
      numberActionEvaluate: null,
      timeBetweenExecutionsCheckbox: false,
      timeBetweenExecutions: null,
      completionTimeCheckbox: false,
      completionTime: null,
      executionTimeExpired: false,
      executionTimeExpiredOption: "0",
      executionTimeExpiredValue: null,
      timeForQuizCheckbox: false,
      timeForQuiz: null,
      automaticScoring: false,
      typeScore: "0",
      minimumScore: "0",
      scoreFactor: null,
      recordResultsSwitch: false,
      recordResults: "0",
      showResultsCompletion: false,
      showResultsCompletionOption: null,
    });
  }, [settingLessonModal]);


  return (
    <>
      <div className="display-setting-content">
        <Row>
          <Col className="col-menu-setting">
            <Tabs defaultActiveKey="1" tabPosition={"left"} items={itemsTab}
              onTabClick={onTabClick} />
          </Col>
        </Row>
      </div>
      <Modal
        title={t("Quy tắc", "Quy tắc")}
        open={isModalOpen}
        width={920}
        className="rule-modal"
        onCancel={handleCancel}
        footer={[
          <Button key="ok" type="primary" onClick={handleOk}>
            OK
          </Button>,
        ]}
      >
        <Table columns={columns} dataSource={data} pagination={false} />
      </Modal>
    </>
  );
}